
import { defineComponent } from "vue";

import ChatMessages from "@/components/chat/ChatMessages.vue";
import ChatTextField from "@/components/chat/ChatTextField.vue";
import UploadImage from "@/components/chat/UploadImage.vue";
import SendButton from "@/components/chat/SendButton.vue";

import useMessage from "@/composition/chat/message";
import useUpload from "@/composition/chat/upload";

export default defineComponent({
  components: {
    ChatMessages,
    ChatTextField,
    UploadImage,
    SendButton
  },

  setup() {
    const {
      messages,
      message,
      sendTextMessage,
      sendImageMessage
    } = useMessage();

    const { uploadImages } = useUpload();

    async function onUploadFilesSelected(event: Event) {
      const target = event.target as HTMLInputElement;
      const files = target.files as FileList;
      const uploadedImages = await uploadImages(files);
      sendImageMessage(uploadedImages);
    }

    return {
      messages,
      message,
      sendTextMessage,
      onUploadFilesSelected
    };
  }
});
